import React, {Component} from 'react'
import {defineMessages, injectIntl} from 'react-intl'

const messages = defineMessages({
    never: {
        id: 'invoice.recurring.ending_type.never_label',
        defaultMessage: 'Never ends',
    },
    by: {
        id: 'invoice.recurring.ending_type.by_label',
        defaultMessage: 'Ends by',
    },
    after: {
        id: 'invoice.recurring.ending_type.after_label',
        defaultMessage: 'Ends after',
    },
})


class EndingTypeLabel extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            endingType: this.props.endingType,
        }
    }
    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            endingType: nextProps.endingType,
        })
    }

    render() {
        switch (this.state.endingType) {
            case 'never':
            case 'after':
            case 'by':
                return this.props.intl.formatMessage(messages[this.state.endingType])
        }
        return ''
    }

}

export default injectIntl(EndingTypeLabel)





// WEBPACK FOOTER //
// ./src/invoice/recurring/endingtypelabel.component.jsx